import { useEffect } from "react";

export default function useEnforceLightMode() {
  useEffect(() => {
    const root = document.documentElement;
    const hadDarkClass = root.classList.contains("dark");
    root.classList.remove("dark");

    return () => {
      if (hadDarkClass) {
        root.classList.add("dark");
      }
    };
  }, []);
}
